import React, { Component, useState } from "react";
import { Link, useHistory, useLocation, useNavigate } from "react-router-dom";
import {
    Layout,
    Menu,
    Button,
    Row,
    Col,
    Typography,
    Form,
    Input,
    Switch,
} from "antd";
import signinbg from "../assets/images/car-sign-in.png";
import {
    EyeTwoTone,
    EyeInvisibleOutlined,
} from "@ant-design/icons";
import logo from '../assets/images/logo.png';
import Post from '../services/Post';
import OTPInput from "otp-input-react";

function onChange(checked) {
    console.log(`switch to ${checked}`);
}
const { Title } = Typography;
const { Header, Footer, Content } = Layout;

const ForgotPassword = () => {
    const location = useLocation();
    const [formType, setFormType] = useState('otp');
    const [loading, setLoading] = useState(false);
    const [OTP, setOTP] = useState();
    const navigate = useNavigate();

    const onFinish = () => {
        setLoading(true);

        const value = OTP;
        Post.VerifyUpdateOtp({ value, id: location.state.id })
            .then((res) => {
                if (res.error) {
                    console.error(res.error);
                }
                if (res.success) {
                    console.log({ res });
                    localStorage.setItem('user', JSON.stringify(res.data));
                    setFormType('password');
                }
            })
            .finally(() => setLoading(false));
    };

    const handleForgetPassword = (values) => {
        setLoading(true);

        const password = values.password;
        Post.UpdatePassword({ password })
            .then((res) => {
                if (res.error) {
                    console.error(res.error);
                }
                console.log(res);
                navigate("/user/home");
            })
            .finally(() => setLoading(false));
    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };
    return (
        <>
            <Layout className="layout-default layout-signin">
                <Header>
                    <div className="header-col header-brand header-logo" onClick={() => navigate("/")}>
                        <img src={logo} alt="" height={70} />
                    </div>
                </Header>
                <Content className="signin">
                    <Row gutter={[24, 0]} justify="space-around">
                        <Col
                            xs={{ span: 24, offset: 0 }}
                            lg={{ span: 6, offset: 2 }}
                            md={{ span: 12 }}
                        >
                            <Title className="mb-15">Sign In</Title>
                            {formType === "otp" ? (
                                <>
                                    <Title className="font-regular text-muted" level={5}>
                                        Enter 6 digits OTP sent to your phone number
                                    </Title>
                                    <div className="otp-form">
                                        <label>Enter OTP</label>
                                        <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={false} secure style={{ marginBottom: 20, padding: 10 }} />
                                    </div>

                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{
                                            width: "100%",
                                            backgroundColor: "#a6cc43",
                                            borderColor: "#a6cc43",
                                        }}
                                        onClick={onFinish}
                                        loading={loading}
                                    >
                                        Submit OTP
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Title className="font-regular text-muted" level={5}>
                                        Enter new Password
                                    </Title>
                                    <Form
                                        onFinish={handleForgetPassword}
                                        onFinishFailed={onFinishFailed}
                                        layout="vertical"
                                        className="row-col"
                                    >
                                        <Form.Item
                                            className="username"
                                            label="Password"
                                            name="password"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please input your password!",
                                                },
                                            ]}
                                        >
                                            <Input.Password
                                                placeholder="Enter password"
                                                iconRender={(visible) =>
                                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                                }
                                            />
                                        </Form.Item>

                                        <Form.Item>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: "#a6cc43",
                                                    borderColor: "#a6cc43",
                                                }}
                                                loading={loading}
                                            >
                                                Update Password
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </>
                            )}
                        </Col>

                        <Col
                            className="sign-img"
                            style={{ padding: 12 }}
                            xs={{ span: 24 }}
                            lg={{ span: 12 }}
                            md={{ span: 12 }}
                        >
                            <img src={signinbg} alt="" />
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </>
    );
}

export default ForgotPassword;